export default function imageDataUrlToBlob(dataUrl) {
  if (typeof dataUrl !== 'string') {
    return null
  }

  const match = dataUrl.match(/^data:([^;,]+);base64,([A-Za-z0-9+/=\s]+)$/)

  if (!match) {
    return null
  }

  try {
    const binary = window.atob(match[2].replace(/\s/g, ''))
    const bytes = new Uint8Array(binary.length)

    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index)
    }

    return new window.Blob([bytes], { type: match[1] })
  } catch {
    return null
  }
}
